import React from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';

import Block from '../../atoms/Block';
import FooterLogo from '../../../assets/footer-logo.png';

const Background = styled.div`
  background-color: #000;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;

  ${space}
`;

const FooterTextWrapper = styled.div`
  margin-bottom: 8px;
`;

const FooterLogoWrapper = styled.img`
  width: 7%;
`;

const Footer = () => {
  return (
    <footer>
      <Background py={['32px', '32px', '64px']}>
        <FooterTextWrapper>
          <Block mb={1}>Copyright 2020 © Maxim Caterers Ltd. All rights reserved.</Block>
          <Block>© 2020 Hasbro. All rights reserved.</Block>
          <Block>Licensed by:</Block>
        </FooterTextWrapper>
        <FooterLogoWrapper src={FooterLogo} />
      </Background>
    </footer>
  );
};

export default Footer;
